export default __webpack_public_path__ + "static/media/avatarEdit.f800056f.svg";